<template>
    <router-view />
</template>

<script setup>
import { enum_status } from '@/api/index'

enum_status().then(res => {
    if(res.code == 200 && res.data){
        localStorage.setItem('enumStatus', JSON.stringify(res.data))
    }
})

//处理表格缩放的bug
const debounce = (callback, delay) => {
    let tid;
    return function (...args) {
        const ctx = self;
        tid && clearTimeout(tid);
        tid = setTimeout(() => {
            callback.apply(ctx, args);
        }, delay);
    };
};

const _ = (window).ResizeObserver;
(window).ResizeObserver = class ResizeObserver extends _ {
    constructor(callback) {
        callback = debounce(callback, 20);
        super(callback);
    }
};
</script>

<style lang="scss">
div {
    box-sizing: border-box;
}
</style>
